import React from "react";
import { IonSkeletonText, IonSlides } from "@ionic/react";
import cx from "classnames";

const sliderConfig = {
  spaceBetween: 16,
  breakpoints: {
    1024: {
      slidesPerView: 7,
      slidesPerGroup: 7,
    },
    720: {
      slidesPerView: 6,
      slidesPerGroup: 6,
    },
    768: {
      slidesPerView: 5,
      slidesPerGroup: 5,
    },
    680: {
      slidesPerView: 4.5,
      slidesPerGroup: 4.5,
    },
    640: {
      slidesPerView: 4,
      slidesPerGroup: 4,
    },
    480: {
      slidesPerView: 4.5,
      slidesPerGroup: 4.5,
    },
    320: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
  },
};

const categoriesSkeleton = [...Array(10).keys()];

interface ProductShelfSkeletonProps {
  haveImage?: boolean;
  classnameSkeleton?: string;
}

const ProductShelfSkeleton = ({ haveImage, classnameSkeleton }: ProductShelfSkeletonProps) => {
  return (
    <div className={cx("flex flex-col  min-h-[12.875rem] justify-between ", classnameSkeleton)}>
      <div className="flex justify-between">
        <IonSkeletonText className="w-[6.71rem] h-3 rounded-lg m-0" animated />
        <IonSkeletonText className="w-[5.52125rem] h-3 rounded-lg m-0" animated />
      </div>
      <div className="flex justify-center items-center gap-1  ">
        {haveImage && <IonSkeletonText className="w-24 h-48 rounded-lg m-0" animated />}
        <IonSlides {...sliderConfig}>
          <div className="flex justify-center items-center gap-1  ">
            {categoriesSkeleton.map((skelet) => {
              return (
                <div key={skelet} className="flex flex-col justify-between items-center gap-2 min-h-[11rem] ">
                  <IonSkeletonText className="w-20 h-20 rounded-lg m-0" animated />

                  <div className="flex flex-col gap-1 items-center">
                    <IonSkeletonText className="w-8 h-3 rounded-lg m-0" animated />
                    <IonSkeletonText className="w-20 h-4 rounded-lg m-0" animated />
                  </div>

                  <IonSkeletonText className="h-9 w-[6.41625rem] rounded-lg m-0" animated />
                </div>
              );
            })}
          </div>
        </IonSlides>
      </div>
    </div>
  );
};

export default ProductShelfSkeleton;
